'use strict';

/**
 * @author Maxim Seredkin
 */

export default function okvedTree() {
    return {
        restrict: 'A',
        template: require('../view/okved-tree.html'),
        scope: {
            selectedItem: '=myModel',
            selectedOkveds: '=myOkveds',
        },
        controller: ['$scope', 'OkvedMultiService',
                     function($scope, OkvedService) {
                         $scope.search = search;
                         $scope.isContainSelect = isContainSelect;
                         $scope.resetAll = function () {
                             $scope.selectedOkveds = [];
                         }
                         

                         $scope.okvedTree = { 0: {}};
                         $scope.path = [];
                         $scope.openOkved = openOkved;
                         $scope.selectOkved = selectOkved;
                         $scope.searchingPath = [];

                         init();

                         // endregion
                        function search() {
                            if ($scope.filter.codeOkved != null && $scope.filter.codeOkved.length != 0) {
                                OkvedService.api.get({
                                    filters: [`'code' EQ '${$scope.filter.codeOkved}'`,
                                            `'status' EQ 'ENABLED'`],
                                }, (data) => {
                                    if (data._embedded != null && Array.isArray(data._embedded) && data._embedded.length > 0) {
                                        OkvedService.api.path({okvedId: data._embedded[0].id}, async (response) => {
                                            $scope.searchingPath = response._embedded;
                                        });
                                    }
                                });
                            }
                        }

                         function isContainSelect(item) {
                             return $scope.selectedOkveds.some(n => n.id === item.id)
                         }
                        
                        function arrayToOkvedTree(okvedArray, parent = 0) {
                            if (Array.isArray(okvedArray)) {
                                $scope.okvedTree[parent] = { ...$scope.okvedTree[parent], nodes: okvedArray };
                                okvedArray.forEach(item => {
                                    $scope.okvedTree[item.id] = item;
                                })
                            }
                        }

                        function init() {
                            $scope.loading = true;
                            $scope.filter = {};
                            $scope.columns = [{
                                data: 'code',
                            }, {
                                data: 'name',
                            }];

                            OkvedService.api.root(null, (data) => {
                                arrayToOkvedTree(data._embedded);
                                if ($scope.selectedItem) {
                                    OkvedService.api.path({okvedId: $scope.selectedItem.id}, async (response) => {
                                        $scope.searchingPath = response._embedded;
                                    });
                                }
                                $scope.loading = false;
                            });
                        }

                        function openOkved(item, isOpen, searchingPath) {
                            if (!item) return;
                            if (!item.nodes) {
                                OkvedService.api.childs({okvedId: item.id}, (data) => {
                                    item.nodes = data._embedded;
                                    arrayToOkvedTree(data._embedded, item.id);

                                    if (isContainSelect(item)) {
                                        // без nodes
                                        $scope.selectedOkveds = $scope.selectedOkveds.concat(item.nodes);
                                    }

                                    if (!item.parent) {
                                        $scope.path = [item];
                                    } else {
                                        const checkedIndex = $scope.path.findIndex(n => n.id === item.parent.id);
                                        const checkedArray = $scope.path.slice(0, checkedIndex + 1);
                                        $scope.path = [...checkedArray, item];
                                    }
                                    if (searchingPath && searchingPath.length > 0) {
                                        const currentPath = searchingPath.slice(1);
                                        openOkved($scope.okvedTree[searchingPath[0].id], false, currentPath);
                                    } else {
                                        $scope.searchingPath = [];
                                    }
                                });
                            } else {
                                if (isContainSelect(item) && $scope.okvedTree[item.id].nodes.some(n => !$scope.selectedOkveds.some(m => m.id === n.id))) {
                                    // без nodes
                                    $scope.selectedOkveds = $scope.selectedOkveds.concat($scope.okvedTree[item.id].nodes);
                                }
                                if (!item.parent) {
                                    $scope.path = isOpen ? [] : [item];
                                } else {
                                    const checkedIndex = $scope.path.findIndex(n => n.id === item.parent.id);
                                    const checkedArray = $scope.path.slice(0, checkedIndex + 1);
                                    $scope.path = isOpen ? [...checkedArray] : [...checkedArray, item];
                                }

                                if (searchingPath && searchingPath.length > 0) {
                                    const currentPath = searchingPath.slice(1);
                                    openOkved($scope.okvedTree[searchingPath[0].id], false, currentPath);
                                } else {
                                    $scope.searchingPath = [];
                                }
                            }
                        }

                        function recursUpdate(items, forceCheck) {
                            if (forceCheck) {
                                $scope.selectedOkveds = $scope.selectedOkveds.filter(n => !items.some(m => m.id === n.id));
                                for (let item of items) {
                                    if ($scope.okvedTree[item.id].nodes) {
                                       recursUpdate($scope.okvedTree[item.id].nodes, forceCheck)
                                    }
                                }
                            } else {
                                $scope.selectedOkveds = $scope.selectedOkveds.concat(items);
                                for (let item of items) {
                                    if ($scope.okvedTree[item.id].nodes) {
                                       recursUpdate($scope.okvedTree[item.id].nodes, forceCheck)
                                    }
                                }
                            }
                        }

                        function selectNodes(node, isChecked) {
                            const checkedIndex = node.parent ? $scope.path.findIndex(n => n.id === node.parent.id) : -1;
                            if (checkedIndex === -1 && node.parent ) return;

                            if (isChecked) {
                                const nonCheckedArray = $scope.path.slice(0, checkedIndex + 1);
                                $scope.selectedOkveds = $scope.selectedOkveds.filter(n => !nonCheckedArray.some(m => m.id === n.id));
                            } else {                           
                                const nonCheckedArray = $scope.path.slice(0, checkedIndex + 1).reverse();
                                nonCheckedArray.forEach(item => {
                                    if ($scope.okvedTree[item.id].nodes.every(n => $scope.selectedOkveds.some(m => m.id === n.id))) {
                                        $scope.selectedOkveds.push(item);
                                    }
                                })    
                            }
                            if ($scope.okvedTree[node.id].nodes) recursUpdate($scope.okvedTree[node.id].nodes, isChecked);
                        }

                        function selectOkved($event, item) {
                            $event.stopPropagation();
                            const isChecked = isContainSelect(item);
                            if (isChecked) {
                                $scope.selectedOkveds = $scope.selectedOkveds.filter(n => n.id !== item.id);
                            } else {
                                $scope.selectedOkveds.push(item);
                            }
                            selectNodes(item, isChecked)
                        }

                         $scope.$watch('searchingPath', function(newValue, oldValue) {
                            if (newValue !== oldValue && newValue.length) {
                                openOkved($scope.okvedTree[newValue[0].id], false, newValue);
                            }
                         });
                     }],
    };
}
